import { Col, Row, Form } from "react-bootstrap"
export const InputCom = ({ label, type, disable, id, placeholder, value, handleInputChange }) => {
    return (<>
        <Row className="mt-2">
            <Col lg='5'><div className="d-flex align-items-center w-100 h-100"><h6 className="file-form-h6-tag">{label}</h6></div></Col>
            <Col lg='7'><div>
                <Form.Control
                    as={type === 'textarea' ? 'textarea' : 'input'}
                    type={type === 'textarea' ? undefined : type}
                    rows={type === 'textarea' ? 3 : undefined}
                    disabled={disable}
                    id={id}
                    className="w-100 file-cabinet-input"
                    placeholder={placeholder}
                    onChange={handleInputChange}
                    value={value}
                    style={{
                        height: type === 'textarea' ? undefined : '44px',
                        border: '1px solid #474747',
                        color: '#333',
                    }}
                />
            </div></Col>
        </Row>
        <style>{`
            .file-cabinet-input::placeholder { color: #474747 !important; opacity: 1; }
            .file-cabinet-input { color: #474747 !important; }
            .file-cabinet-input:focus { outline: none !important; box-shadow: none !important; border-color: #474747 !important; }
        `}</style>
    </>)
}

export const InputSelectCom = ({ label, placeholder, id, disable, selectTypeValue, selectTypeLabel, selectInfo, value, handleSelectChange,onBlurfun,warninglabel }) => {
    console.log('selectInfo', selectInfo)
    return (
        <Row className="mt-2">
            <Col lg="5"><div className="d-flex align-items-center w-100"><h6 className="file-form-h6-tag">{label}</h6></div></Col>
            <Col lg="7">
                <div>
                    <Form.Select aria-label="Default select example" disabled={disable} value={value} onChange={handleSelectChange} id={id} onBlur={onBlurfun} style={{ height: '44px', border: '1px solid #474747', color: '#474747' }}>
                        <option value='' disabled defaultValue>{placeholder}</option>
                        {selectInfo?.map((item, index) => (<option key={index} value={item[selectTypeValue]}> {item[selectTypeLabel]}  </option>))}
                    </Form.Select>
                </div>
                {warninglabel && <spam className='text-danger'>{warninglabel}</spam> }

            </Col>
        </Row>

    )
}
